import api from './api';

/**
 * Notary Offices Service (User)
 * Handles notary office API calls for user app
 */
const notaryOfficesService = {
    /**
     * Get all notary offices
     * @param {Object} params - Query parameters (search, city, etc.)
     * @returns {Promise<Object>}
     */
    getAll: async (params = {}) => {
        const queryString = new URLSearchParams(params).toString();
        return api.get(`/user/notary-offices${queryString ? `?${queryString}` : ''}`);
    }
};

export default notaryOfficesService;
